// Toggle for frontend API logging (set window.KTV_API_LOG=true to enable)
export function isApiLogEnabled() {
  return Boolean(window && window.KTV_API_LOG);
}

// Wrapper for fetch with logging
export async function fetchWithLog(url, options = {}) {
  if (isApiLogEnabled()) {
    console.log('[KTV-API-LOG] Request:', url, options);
  }
  try {
    const response = await fetch(url, options);
    if (isApiLogEnabled()) {
      console.log('[KTV-API-LOG] Response:', url, response);
    }
    return response;
  } catch (err) {
    if (isApiLogEnabled()) {
      console.error('[KTV-API-LOG] Error:', url, err);
    }
    throw err;
  }
}

// TO-BE: Detection unificata per tutti gli ambienti - CENTRALIZZATA
function detectLocalDevelopment() {
  if (typeof window === 'undefined') return false;
  
  // Electron detection (usa window.ktvEnv esposta da preload.js)
  if (window.ktvEnv && window.ktvEnv.isElectron) {
    return true;
  }
  
  // TO-BE: Local development detection dinamica
  const hostname = window.location.hostname;
  const port = window.location.port;
  
  // Usa le variabili d'ambiente se disponibili (Electron)
  const expectedPort = window.ktvEnv?.proxyPort || port;
  
  // Se stiamo accedendo direttamente al server unificato
  if (hostname === 'localhost' && port === expectedPort) {
    return true;
  }
  
  // Se stiamo accedendo tramite 127.0.0.1
  if (hostname === '127.0.0.1' && port === expectedPort) {
    return true;
  }
  
  // Fallback per compatibilità (deprecato)
  if (hostname === 'localhost' && (port === '3003' || port === '3443')) {
    console.warn('[API-BASE] Using legacy port detection. Update to use PROXY_PORT.');
    return true;
  }
  
  return false;
}

// TO-BE: API Base URL unificata
export const API_BASE = detectLocalDevelopment()
  ? `${window.location.protocol}//${window.location.hostname}:${window.location.port}`
  : '';

export function apiUrl(path) {
  // path deve iniziare con /api o /proxy
  return API_BASE + path;
}
